<template>
  <v-row dense justify="center">
    <v-col cols="12" sm="10" md="8">
      <v-card>
        <v-sheet dark color="primary" class="py-3">
          <v-row dense>
            <v-col cols="12" class="text-center">
              <v-icon color="secondary" size="50">mdi-key</v-icon>
            </v-col>
            <v-col cols="12" class="text-center">
              <h3 class="secondary--text">Alterar Senha</h3>
            </v-col>
          </v-row>
        </v-sheet>
        <v-card-text>
          <v-form @submit="submit" v-model="form.valid" ref="form" id="reset" lazy-validation>
            <v-text-field
              label="Senha atual"
              v-model="user.password"
              :rules="form.obrigatorioRule"
              :error-messages="form.messages.password"
              type="password"
              required/>
            <v-text-field
              label="Nova Senha"
              v-model="user.new_password"
              :rules="form.obrigatorioRule"
              :error-messages="form.messages.new_password"
              type="password"
              required/>
            <v-text-field
              label="Confirmar Senha"
              v-model="user.new_password_confirmation"
              :rules="form.confirmarSenhaRules"
              :error-messages="form.messages.new_password_confirmation"
              type="password"
              required/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="$router.back()">Cancelar</v-btn>
          <v-btn text type="submit" form="reset" :disabled="!form.valid" color="success">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { Profile } from '@/services/resources'

export default {
  data () {
    return {
      user: {
        password: '',
        new_password: '',
        new_password_confirmation: ''
      },
      form: {
        valid: false,
        messages: this.newErrorMessages(),
        obrigatorioRule: [
          v => !!v || 'Campo obrigatório'
        ],
        confirmarSenhaRules: [
          v => (v === this.user.new_password) || 'Senhas não são iguais'
        ]
      }
    }
  },
  methods: {
    submit (e) {
      e.preventDefault()
      this.form.messages = this.newErrorMessages()
      if (this.$refs.form.validate()) {
        Profile.changePassword(this.user)
          .then(response => {
            this.$toasted.global.success({ message: 'Senha alterada' })
            this.clear()
          })
          .catch(responseError => {
            if (responseError.status === 422) {
              Object.keys(responseError.data).forEach(key => {
                this.form.messages[key] = responseError.data[key]
              })
              this.$toasted.global.error({ message: 'Dados inválidos' })
            }
          })
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    newErrorMessages () {
      return {
        password: [],
        new_password: [],
        new_password_confirmation: []
      }
    }
  }
}
</script>
